export default "/profile/images/API.svg?02e2ace5e0068e120b7343838bc08998";